export class Utente {
  id: string;
  username: string;
  interno: boolean;
  email: string;
  nome: string;
  cognome: string;
  label: string;
}
